__turbopack_context__.v({
  "cryptoContainer": "QuoteNewsSection-module-scss-module__BwNghG__cryptoContainer",
  "styledTabsWrapper": "QuoteNewsSection-module-scss-module__BwNghG__styledTabsWrapper",
});
